import { InMemoryCache } from "apollo-cache-inmemory"
import { ApolloClient } from "apollo-client"
import { split } from "apollo-link"
import { createHttpLink } from "apollo-link-http"
import { WebSocketLink } from "apollo-link-ws"
import { SubscriptionClient } from "subscriptions-transport-ws"
import { getMainDefinition } from "apollo-utilities"
import { get } from "browser-cookies"
// @ts-ignore
const URI = process.env.NODE_ENV === "development" ? "hasura-test.guokr.cn/v1/graphql" : window.HASURA_HOST

export const cache = new InMemoryCache()

// hasura使用固定token
const hasuraToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2MzJiNWFlNC01MjY5LTQxYzYtYjU4MC0xNTEyMDY0MWIzZDAiLCJleHBpcmVzX2luIjoyMjM3MDAwMDAwLCJzY29wZXMiOlsidXNlciIsImd1ZXN0Il0sImh0dHBzOi8vaGFzdXJhLmlvL2p3dC9jbGFpbXMiOnsieC1oYXN1cmEtYWxsb3dlZC1yb2xlcyI6WyJlZGl0b3IiLCJ1c2VyIiwiYWRtaW4iLCJ0cnVlX2VkaXRvciIsInNpZGVfZWRpdG9yIiwib3BfZWRpdG9yIiwiZmluYW5jZSIsInBob3RvZXIiXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoiYWRtaW4iLCJ4LWhhc3VyYS11c2VyLWlkIjoiNjMyYjVhZTQtNTI2OS00MWM2LWI1ODAtMTUxMjA2NDFiM2QwIiwieC1oYXN1cmEtY3VzdG9tIjoiY3VzdG9tLXZhbHVlIn19.OW1uqzijlv6qMX12euv0yBAF4ZFO0FQEHwsfX7ULltQ'
// 本地数据及其他服务获取的数据（存储在客户端中）
const httpLink = createHttpLink({
    uri: `https://${URI}`,
    fetch: (uri, options: any) => {
        const body = JSON.parse(options.body || "{}")
        if (/^(delete|update_board|update_species|update_eat_board)/.test(body.operationName)) {
            const asyncToken = get("ad_token")
            options.headers.Authorization = `Bearer ${asyncToken}`
        } else {
            options.headers.Authorization = `Bearer ${hasuraToken}`
        }
        return fetch(uri, options)
    },
})
const wsClient = new SubscriptionClient(
    `wss://${URI}`,
    {
        reconnect: true,
        lazy: true,
        connectionParams: () => ({
            headers: {
                Authorization: `Bearer ${hasuraToken}`,
            },
        }),
    },
)
const wsLink = new WebSocketLink(wsClient)

const link = split(
    ({ query }) => {
        // return true
        const definition = getMainDefinition(query)
        return (
            definition.kind === "OperationDefinition" &&
            definition.operation === "subscription"
        )
    },
    wsLink,
    httpLink,
)

const client = new ApolloClient({ link, cache })

export default client
